import type { RespirationDataPoint } from '@/domain/behavior';
import { formatMachineNumber } from '@/utils/localeFormatters';

export interface RespirationExportData {
    date: string;
    respiration: string;
    swimSpeed: string;
}

export function prepareRespirationExportData(respirationDataPoints: RespirationDataPoint[]): {
    columns: string[];
    data: RespirationExportData[];
} {
    const exportData: RespirationExportData[] = respirationDataPoints.map((point) => ({
        date: point.day,
        respiration: formatMachineNumber(point.respiration, 2) ?? '-',
        swimSpeed: formatMachineNumber(point.swimSpeed, 2) ?? '-',
    }));

    // Column format follows the pattern: location.name, cage.name, day.{field}
    const locationInfoColumns = ['location.name', 'cage.name'];
    const dataColumnNames = exportData.length > 0 ? Object.keys(exportData[0]) : [];
    const formattedDataColumnNames = dataColumnNames.map((e) => `day.${e}`);
    const allColumnNames = [...locationInfoColumns, ...formattedDataColumnNames];

    return {
        columns: allColumnNames,
        data: exportData,
    };
}
